import React, { useEffect } from "react"

import Button from "@fuse/sharedComponents/buttons/SolidBtn"
import LoadingSpinner from "@fuse/sharedComponents/loader/LoadingSpinner"
import FancyText from "@fuse/sharedComponents/typography/FancyText"
import { TWebUser } from "@letshang/constants"
import { isEmpty } from "lodash-es"
import { useRecoilState } from "recoil"

import { screenState, userState } from "@fuse/recoil/signup"

import { GenderPronounMap } from "@fuse/utils/common"

import { useSignup } from "@fuse/pages/signUp/controller"

export const genderOptions = Object.entries(GenderPronounMap).map(
  ([key, value]) => ({
    value: key,
    label: value,
  }),
)

const Gender = () => {
  const [, setStep] = useRecoilState(screenState)
  const [selected, setSelected] = React.useState<string | null>(null)
  const [user, setUser] = useRecoilState(userState)

  const { isLoading } = useSignup()

  const handleNext = () => {
    setUser((prev: TWebUser) => ({
      ...prev,
      gender: selected,
    }))
    setStep(5)
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-screen w-full">
      <div className="w-[90%] max-w-sm mb-5 md:mb-10 text-start">
        <p className="text-white/30 text-left text-sm mt-10 md:mt-0 lg:mt-0 font-medium">
          STEP 2
        </p>
        <FancyText className="text-xl md:text-2.5xl mt-[10px] text-white font-semibold">
          Setting up your profile
        </FancyText>
      </div>
      <div className="relative z-[10]">{isLoading && <LoadingSpinner />}</div>
      <div className="w-[90%] max-w-sm bg-white/10 relative rounded-2xl p-10 space-y-6">
        {/* Title */}
        <div className="text-left">
          <h2 className="text-white text-2xl font-semibold">
            Hi {user?.firstName || user?.name}! How can we{" "}
            <span className="bg-gradient-to-r from-[#C190FF] to-[#A9A4FF] inline-block text-transparent bg-clip-text">
              refer
            </span>{" "}
            to you?
          </h2>

          <p className="text-white/35 mt-2">
            Sharing your gender helps us suggest better plans. Your info stays
            private.
          </p>
        </div>

        <div className="flex items-center gap-2 pb-24 flex-col">
          {Object.keys(GenderPronounMap)?.map((item, index) => {
            return (
              <SelectInput
                key={index}
                label={GenderPronounMap[item]}
                isSelected={selected === item}
                onClick={() => {
                  setSelected(item)
                }}
              />
            )
          })}
        </div>

        <button
          className={`w-full bg-white/20 text-white py-3 rounded-full font-medium transition ${!isEmpty(selected) ? "" : "opacity-50"}`}
          onClick={() => {
            handleNext()
          }}
          disabled={isEmpty(selected)}
        >
          Continue
        </button>
      </div>
    </div>
  )
}

export default Gender

interface SelectInputProps {
  label: string
  isSelected: boolean
  onClick?: () => void
}

export const SelectInput = ({
  label,
  isSelected,
  onClick,
}: SelectInputProps) => {
  return (
    <div
      onClick={onClick}
      className={`px-4 bg-white/30 h-10 rounded-md flex w-full items-center cursor-pointer ${isSelected ? "border" : ""}`}
    >
      <p className="text-white text-sm">{label}</p>
    </div>
  )
}
